import { Instagram, Mail, Phone } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/content";
import { Wordmark } from "./Logo";
import { scrollToId } from "../utils/scroll";

export const Footer = () => (
  <footer
    className="border-t border-[rgba(247,244,239,0.1)] bg-[#100e0c]"
    data-testid="footer"
  >
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <Wordmark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#8f887f]">
            A café diner in Lanka, Varanasi — slow coffee, warm plates and a room that asks you to
            stay a while.
          </p>
        </div>
        <nav aria-label="Footer">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#8f887f]">Explore</p>
          <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  type="button"
                  onClick={() => scrollToId(l.id)}
                  data-testid={`footer-link-${l.id}`}
                  className="text-sm text-[#b5afa7] transition-colors hover:text-[#d4af37]"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#8f887f]">
            Say hello
          </p>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a
                href={BUSINESS.phones[0].href}
                className="inline-flex items-center gap-2.5 text-[#b5afa7] transition-colors hover:text-[#d4af37]"
                data-testid="footer-phone-link"
              >
                <Phone size={14} aria-hidden="true" /> {BUSINESS.phones[0].label}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${BUSINESS.email}`}
                className="inline-flex items-center gap-2.5 text-[#b5afa7] transition-colors hover:text-[#d4af37]"
                data-testid="footer-email-link"
              >
                <Mail size={14} aria-hidden="true" /> {BUSINESS.email}
              </a>
            </li>
            <li>
              <a
                href={BUSINESS.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 text-[#b5afa7] transition-colors hover:text-[#d4af37]"
                data-testid="footer-instagram-link"
              >
                <Instagram size={14} aria-hidden="true" /> {BUSINESS.instagramHandle}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-[rgba(247,244,239,0.08)] pt-7 text-xs text-[#8f887f] md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Roma's Café Diner, Varanasi.</p>
        <p className="italic" data-testid="footer-demo-note">
          Demo website — imagery is curated stock pending Roma's official photography.
        </p>
      </div>
    </div>
  </footer>
);
